<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Travailler en groupe et en équipe" index-progression-courante="3" index-progression-secondaire="8"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="apprendreseformer"/>
    <footer-applis ecran-precedent="utilisercodessociaux" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'travaillerequipe',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'identifie les personnes et adopte une posture pour apprendre'
      }, {
        niveau: 2,
        valeur: 'J\'adopte une attitude attentive pour travailler, peut aider les autres et accepte d’être aidé'
      }, {
        niveau: 3,
        valeur: 'Je fais des propositions et accepte de les négocier'
      }, {
        niveau: 4,
        valeur: 'Je participe activement au travail collectif en variant ma place et mon rôle dans le groupe'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.utilisercodessociaux = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('apprendreseformer');
    }
  }
}
</script>
